const puzzles = {
  minValue: 1,
  maxValue: 135960,
}

export { puzzles }
